// extracted by mini-css-extract-plugin
export default {"Container":"Header_Container__dktNR","text":"Header_text__uY0+e","header__content":"Header_header__content__VdiZ7"};